import { MutationTree } from "vuex";
import { ApplicantState, Applicant, ApplicantList, AuditList } from "../types";

const mutations: MutationTree<ApplicantState> = {
  setApplicants(state, applicants: ApplicantList) {
    state.applicants = applicants;
  },
  setApplicantAudits(state, audits: AuditList) {
    state.audits = audits;
  },
  setAllApprovedApplicants(state, applicants: ApplicantList) {
    state.allApprovedApplicants = applicants;
  },
  setApprovedApplicantListOrder(state, items: Array<Applicant>) {
    state.allApprovedApplicants.items = items;
  },
  setAllRejectedApplicants(state, applicants: ApplicantList) {
    state.allRejectedApplicants = applicants;
  },
  setAllPendingApplicants(state, applicants: ApplicantList) {
    state.allPendingApplicants = applicants;
  },
  //All Applicants
  setPageIndex(state, pageIndex: number) {
    state.applicants.pageIndex = pageIndex;
  },
  setHasNextPage(state, hasNextPage: boolean) {
    state.applicants.hasNextPage = hasNextPage;
  },
  pushNewApplicants(state, applicants: Applicant[]) {
    state.applicants.items.push(...applicants);
  },
  //All Approved Applicants
  setApprovedPageIndex(state, pageIndex: number) {
    state.allApprovedApplicants.pageIndex = pageIndex;
  },
  setHasNextApprovedPage(state, hasNextPage: boolean) {
    state.allApprovedApplicants.hasNextPage = hasNextPage;
  },
  pushNewApprovedApplicants(state, applicants: Applicant[]) {
    state.allApprovedApplicants.items.push(...applicants);
  },

  // All Rejected Applicants
  setRejectedPageIndex(state, pageIndex: number) {
    state.allRejectedApplicants.pageIndex = pageIndex;
  },
  setHasNextRejectedPage(state, hasNextPage: boolean) {
    state.allRejectedApplicants.hasNextPage = hasNextPage;
  },
  pushNewRejectedApplicants(state, applicants: Applicant[]) {
    state.allRejectedApplicants.items.push(...applicants);
  },

  //Current Applicant being viewed
  setCurrentApplicant(state, applicant: Applicant) {
    state.currentApplicant = applicant;
  },
  setIsViewing(state, isViewing) {
    state.isViewing = isViewing;
  },
  // Set Sort Order And SortBy
  setSortOrder(state, sortOrder) {
    state.sortOrder = sortOrder;
  },
  setSortBy(state, sortBy) {
    state.sortBy = sortBy;
  },
  setIsLoadingCurrentApplicant(state, isLoadingCurrentApplicant) {
    state.isLoadingCurrentApplicant = isLoadingCurrentApplicant;
  },
  setIsFetchingApplicants(state, isFetchingApplicants) {
    state.isFetchingApplicants = isFetchingApplicants;
  },
  setIsFetchingApplicantAudits(state, isFetchingApplicantAudits) {
    state.isFetchingApplicantAudits = isFetchingApplicantAudits;
  },
  setQuery(state, query) {
    state.query = query;
  },
};

export default mutations;
